import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Typography } from "@mui/material";
import { useProgram } from 'app/hooks/useProgram';

const MicrositeSuksesAddLeads = () => {
	const program = useProgram();

	React.useEffect(() => {
		document.querySelector("html").classList.add('overflow-hidden');
	},[]);


	return (
		<Div className='content-padding'>
			<Div className='back-icon'>
				<KeyboardBackspaceIcon />
				<Div className='flex-justify-start' sx={{ marginLeft: '28px' }}>
					<img alt="newleads" src={`${process.env.REACT_APP_IMAGES_PATH}/icons/ic-newleads.png`} width={18} height={20} />
					<Typography variant={"body1"} fontWeight={600} ml={1}>New Leads</Typography>
				</Div>
			</Div>
			<Div className='mt-2'>
				<Typography sx={{ mt: 2 }} fontSize={20} fontWeight={600} textAlign={"center"} color={"black"}>Lead Anda telah tersimpan dan telah dikirimkan ke Agent peserta {program}</Typography>
				<Div className='dis-flex-center' sx={{ mt: 2 }}>
					<img className='illust-state' alt="AddleadsSukses" src={`${process.env.REACT_APP_IMAGES_PATH}/AddleadsSukses.svg`} width={265} height={265} />
				</Div>

				<Div className='flex-justify-center' sx={{ mt: 2 }}>
					<ButtonStyled
						btnText={"Kembali Ke Menu Lead Listing"}
						sx={{ maxWidth: '451px' }}
					/>
				</Div>
			</Div>
		</Div>
	);
};

export default MicrositeSuksesAddLeads;